import type { BottomBars } from "@be-miniapp/types"

type HomeSession = {
  sessions?: Array<{
    name?: string
    data?: unknown
  }>
  tier_background?: unknown
}

export function hasMeaningfulHomeSession(data: unknown): data is HomeSession {
  if (!data || typeof data !== "object") return false

  const sessionData = (data as HomeSession).sessions
  const sessions = Array.isArray(sessionData) ? sessionData : []

  const hasServices = sessions.some((session) => {
    if (session?.name !== "Service") return false
    if (!Array.isArray(session.data)) return false
    return session.data.length > 0
  })

  const hasBanners = sessions.some((session) => {
    if (session?.name !== "Banner") return false
    if (!Array.isArray(session.data)) return false
    return session.data.length > 0
  })

  const hasDiscovery = sessions.some((session) => {
    if (session?.name !== "HomeDiscovery") return false
    if (!session?.data) return false
    if (Array.isArray(session.data)) {
      return session.data.length > 0
    }
    if (typeof session.data === "object") {
      return Object.keys(session.data as Record<string, unknown>).length > 0
    }
    return false
  })

  const hasBackground = Boolean((data as HomeSession).tier_background)

  return hasServices || hasBanners || hasDiscovery || hasBackground
}

export function hasMeaningfulBottomNavigation(
  data: Partial<BottomBars> | null | undefined
): data is BottomBars {
  if (!data) return false
  if (!Array.isArray(data.icons)) return false
  return data.icons.length > 0
}
